import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Avatar,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./styles-employees.css";
import "./styles.css";

const PersonDetailDialog = ({ selectedPerson, open, onClose }) => {
  if (!selectedPerson) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        sx={{
          backgroundColor: "#228B22",
          color: "#fff",
          padding: "12px 16px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {selectedPerson.name}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.1)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.2)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{ padding: "24px", maxHeight: "70vh", overflow: "auto" }}
        className="employee-modal-content"
      >
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "16px",
            }}
          >
            <Avatar
              alt={selectedPerson.name}
              src={selectedPerson.profile_image}
              sx={{
                width: 120,
                height: 120,
                border: "4px solid #228B22",
                fontSize: "3rem",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              {selectedPerson.name?.charAt(0).toUpperCase()}
            </Avatar>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {/* Basic Information Section */}
              <Grid item xs={12}>
                <Box
                  sx={{ mb: 2, borderBottom: "1px solid #eee", pb: 1 }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "#228B22", fontWeight: "bold", mb: 2 }}
                  >
                    Basic Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Full Name:</strong> {selectedPerson.name}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Staff ID:</strong>{" "}
                        <span
                          style={{ color: "#228B22", fontWeight: 500 }}
                        >
                          {selectedPerson.staff_id ||
                            selectedPerson.uId ||
                            "Not assigned"}
                        </span>
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>User ID:</strong>{" "}
                        {selectedPerson.login_id || "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Gender:</strong>{" "}
                        {selectedPerson.gender || "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Marital Status:</strong>{" "}
                        {selectedPerson.maritalStatus || "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Date of Birth:</strong>{" "}
                        {selectedPerson.dateOfBirth
                          ? new Date(selectedPerson.dateOfBirth)
                              .toLocaleDateString("en-US", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .replace(/,/g, "")
                          : "Not specified"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Email:</strong>
                        <a
                          href={`mailto:${
                            selectedPerson.per_email !== "NONE"
                              ? selectedPerson.per_email
                              : selectedPerson.login_id
                          }`}
                          style={{
                            marginLeft: "4px",
                            color: "#228B22",
                            textDecoration: "none",
                          }}
                        >
                          {selectedPerson.per_email !== "NONE"
                            ? selectedPerson.per_email
                            : selectedPerson.login_id}
                        </a>
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Contact:</strong>{" "}
                        {selectedPerson.contactNumber !== "NONE"
                          ? selectedPerson.contactNumber
                          : "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Nationality:</strong>{" "}
                        {selectedPerson.res_country !== "NONE"
                          ? selectedPerson.res_country
                          : "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Govt ID:</strong>{" "}
                        {selectedPerson.governmentId || "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Blood Group:</strong>{" "}
                        {selectedPerson.bloodGroup || "Not specified"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Employment Information Section */}
              <Grid item xs={12}>
                <Box
                  sx={{ mb: 2, borderBottom: "1px solid #eee", pb: 1 }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "#228B22", fontWeight: "bold", mb: 2 }}
                  >
                    Employment Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Department:</strong>{" "}
                        {selectedPerson.dep_name !== "NONE"
                          ? selectedPerson.dep_name
                          : "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Department ID:</strong>{" "}
                        {selectedPerson.dep_id || "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Role:</strong>{" "}
                        {selectedPerson.role_name !== "NONE"
                          ? selectedPerson.role_name
                          : "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Role ID:</strong>{" "}
                        {selectedPerson.roleId || "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Grade:</strong>{" "}
                        {selectedPerson.grade_id ||
                          selectedPerson.grade ||
                          "Unassigned"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Level:</strong>{" "}
                        {selectedPerson.level !== "NONE" &&
                        selectedPerson.level !== "None"
                          ? selectedPerson.level
                          : "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Level ID:</strong>{" "}
                        {selectedPerson.level_id || "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Employment Type:</strong>{" "}
                        {selectedPerson.empTypeName || "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Emp Type ID:</strong>{" "}
                        {selectedPerson.empTypeId || "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Designation:</strong>{" "}
                        {selectedPerson.desName || "Not assigned"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Work Details Section */}
              <Grid item xs={12}>
                <Box
                  sx={{ mb: 2, borderBottom: "1px solid #eee", pb: 1 }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "#228B22", fontWeight: "bold", mb: 2 }}
                  >
                    Work Details
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Joining Date:</strong>{" "}
                        {selectedPerson.joiningDate !== "NONE"
                          ? selectedPerson.joiningDate
                          : "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Work Location:</strong>{" "}
                        {selectedPerson.workLocation !== "NONE"
                          ? selectedPerson.workLocation
                          : "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Probation Period:</strong>{" "}
                        {selectedPerson.probationPeriod ||
                          "Not specified"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Reporting Manager:</strong>{" "}
                        {selectedPerson.reportingManagerName ||
                          "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Manager ID:</strong>{" "}
                        {selectedPerson.reportingMngId !== "NONE"
                          ? selectedPerson.reportingMngId
                          : "Not assigned"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Created At:</strong>{" "}
                        {selectedPerson.createdAt
                          ? new Date(
                              selectedPerson.createdAt
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          : "Not available"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Leave Allocation Section */}
              <Grid item xs={12}>
                <Box sx={{ mb: 2, borderBottom: "1px solid #eee", pb: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "#228B22", fontWeight: "bold", mb: 2 }}
                  >
                    Leave Allocation
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Annual Leave:</strong>{" "}
                        <span style={{ color: "#1976d2" }}>
                          {selectedPerson.usedAnnualLeave || 0}
                        </span>
                        {" used"} / {selectedPerson.allocatedAnnualLeave || 0}{" days allocated"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Sick Leave:</strong>{" "}
                        <span style={{ color: "#1976d2" }}>
                          {selectedPerson.usedSickLeave || 0}
                        </span>
                        {" used"} / {selectedPerson.allocatedSickLeave || 0}{" days allocated"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Emergency Leave:</strong>{" "}
                        <span style={{ color: "#1976d2" }}>
                          {selectedPerson.usedEmergencyLeave || 0}
                        </span>
                        {" used"} / {selectedPerson.allocatedEmergencyLeave || 0}{" days allocated"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Unpaid Leave:</strong>{" "}
                        {selectedPerson.allocatedUnpaidLeave || 0}{" days allocated"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Address Information Section */}
              <Grid item xs={12}>
                <Box
                  sx={{ mb: 2, borderBottom: "1px solid #eee", pb: 1 }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "#228B22", fontWeight: "bold", mb: 2 }}
                  >
                    Address Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Current Address:</strong>{" "}
                        {selectedPerson.currentAddress !== "NONE"
                          ? selectedPerson.currentAddress
                          : "Not specified"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Permanent Address:</strong>{" "}
                        {selectedPerson.permanentAddress !== "NONE"
                          ? selectedPerson.permanentAddress
                          : "Not specified"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Personal Information Section */}
              <Grid item xs={12}>
                <Box sx={{ mb: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "#228B22", fontWeight: "bold", mb: 2 }}
                  >
                    Personal Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Hobbies:</strong>{" "}
                        {selectedPerson.hobbies !== "{{Hobbies}}" &&
                        selectedPerson.hobbies !== "NONE"
                          ? selectedPerson.hobbies
                          : "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Passion:</strong>{" "}
                        {selectedPerson.passion !== "NONE"
                          ? selectedPerson.passion
                          : "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Short Term Goal:</strong>{" "}
                        {selectedPerson.shortTermGoal || "Not specified"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Long Term Goal:</strong>{" "}
                        {selectedPerson.longTermGoal || "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Primary Language:</strong>{" "}
                        {selectedPerson.primaryLanguage ||
                          "Not specified"}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1.5 }}>
                        <strong>Known Languages:</strong>{" "}
                        {selectedPerson.knownLanguage || "Not specified"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: "#228B22",
            borderColor: "#228B22",
            "&:hover": {
              borderColor: "#1b6b1b",
              backgroundColor: "rgba(34,139,34,0.08)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PersonDetailDialog;